import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import { DATE } from '../../fields';
import { WEEK_VIDEO_REPORT_ID } from './weekVideoReportId';

const weekReportFooterColumnDefinition = [DATE].map(createFooterMapper(WEEK_VIDEO_REPORT_ID));

export default weekReportFooterColumnDefinition;
